// Thème visuel de l'application. Choisi à la construction, par le développeur — il n'y a aucun réglage dans
// l'appli : pour remettre Halloween en octobre, lancer ou construire avec VITE_APP_THEME=halloween
// (par exemple `VITE_APP_THEME=halloween npm run dev`, ou une ligne dans un fichier .env), ou changer
// DEFAULT_APP_THEME dans config/appThemeIds.js.
import { resolveAppTheme } from './appThemeIds.js';

export const APP_THEME = resolveAppTheme(import.meta.env?.VITE_APP_THEME);
